import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.STAFF_AND_MACHINERY_CARDS].GET_AVAILABLE_STAFF_AND_MACHINERY_CARDS]:
		{
			url: '/telematics/v1/available_staff_and_machine_cards_list/:companyId/', // FIXME: fix url
		},
}
